import { StyleSheet } from 'aphrodite'
import { Common } from 'styles'

const styleSheet = {
  container: {
    padding: '0 10px',
    marginTop: 0
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 20,
    position: 'relative'
  },
  sectionLabel: {
    color: 'rgb(51, 122, 183)',
    marginBottom: 3,
    fontWeight: 'bold',
    display: 'block',
    paddingLeft: 1,
    userSelect: 'none'
  },
  fieldContainer: {
    display: 'flex',
    paddingTop: 2,
    marginTop: 10,
    width: '100%',
    fontSize: 10,
    flexWrap: 'wrap'
  },
  delimeter: {
    height: 1,
    width: 240,
    border: 'none',
    padding: 0,
    margin: 0,
    borderBottom: `1px solid ${Common.borderColor}`
  },
  label: {
    flex: '0 0 33%',
    color: '#777',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  value: {
    flex: '0 0 66%',
    color: '#000',
    wordWrap: 'break-word',
    maxWidth: '66%'
  },
  valueWithLabel: {
    maxWidth: '66%'
  },
  valueNoLabel: {
    flex: '0 0 100%'
  },
  download: {
    borderBottom: '1px dashed rgb(0, 105, 180)',
    textDecoration: 'none',
    color: '#000'
  },
  input: {
    padding: 2,
    border: '1px solid #ccc',
    borderRadius: 2,
    color: '#000',
    fontSize: 10,
    outline: 0,
    width: '100%',
    flexGrow: 1,
    boxSizing: 'border-box',
    paddingRight: 35
  },
  inputError: {
    border: '1px solid red'
  },
  button: {
    position: 'absolute',
    backgroundColor: '#efefef',
    border: '1px solid #ccc',
    color: '#000',
    right: 0,
    borderRadius: 2,
    marginRight: 2,
    padding: 1,
    bottom: 2,
    height: 10,
    cursor: 'pointer',
    ':hover': {
      backgroundColor: 'rgb(0, 105, 180)',
      color: '#fff',
      border: '1px solid rgb(0, 105, 180)'
    }
  },
  buttonError: {
    backgroundColor: '#efefef',
    color: '#ccc',
    border: '1px solid #ccc',
    cursor: 'inherit',
    ':hover': {
      backgroundColor: '#efefef',
      color: '#ccc',
      border: '1px solid #ccc'
    }
  },

  textarea: {
    height: 60,
    resize: 'none'
  }
}

const styles = StyleSheet.create(styleSheet)

export { styles as default, styleSheet }



// WEBPACK FOOTER //
// ./src/components/FilterMenu/Section/styles.js